import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import logo from "../assets/logo.png";
import ForgotPasswordModal from "../components/ForgotPasswordModal";
import API_BASE_URL from "../config";

const LoginPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [attempts, setAttempts] = useState(0);
  sessionStorage.setItem("loginLockTime", Date.now());


  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const validateForm = () => {
    const { email, password } = formData;

    // EMAIL EMPTY
    if (!email) {
      toast.error("Please enter your email.");
      return false;
    }

    // EMAIL LEADING / TRAILING SPACE
    if (email.startsWith(" ") || email.endsWith(" ")) {
      toast.error("Email should not start or end with spaces.");
      return false;
    }

    // EMAIL PATTERN VALIDATION
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      toast.error("Please enter a valid email address.");
      return false;
    }

    // PASSWORD EMPTY
    if (!password) {
      toast.error("Please enter your password.");
      return false;
    }

    // PASSWORD LEADING / TRAILING SPACE
    if (password.startsWith(" ") || password.endsWith(" ")) {
      toast.error("Password should not start or end with spaces.");
      return false;
    }

    return true;
  };


  // CHECK IF LOCKED
const isLocked = () => {
  const lockTime = sessionStorage.getItem("loginLockTime");
  if (!lockTime) return false;

  const minutesPassed = (Date.now() - parseInt(lockTime)) / (1000 * 60);

  if (minutesPassed < 5) {
    return true;
  } else {
    // unlock after 5 minutes
    sessionStorage.removeItem("loginLockTime");
    setAttempts(0);
    return false;
  }
};


// const handleSubmit = async (e) => {
//   e.preventDefault();

//   // CHECK IF LOCKED
//   if (isLocked()) {
//     toast.error("Login locked for 5 minutes due to too many failed attempts.");
//     return;
//   }

//   // TOO MANY ATTEMPTS
//   if (attempts >= 5) {
//     toast.error("Too many failed attempts! Locked for 5 minutes.");
//     sessionStorage.setItem("loginLockTime", Date.now());
//     return;
//   }

//   // VALIDATE BEFORE API
//   if (!validateForm()) return;

//   setLoading(true);

//   try {
//     const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(formData),
//     });

//     const data = await response.json();

//     if (response.ok) {
//       toast.success("✅ Login successful!", { position: "top-center" });

//       // RESET attempts on success
//       setAttempts(0);
//       sessionStorage.removeItem("loginLockTime");

//       sessionStorage.setItem("token", data.token);
//       sessionStorage.setItem("userId", data.id);
//       sessionStorage.setItem("roles", JSON.stringify(data.roles));
//       sessionStorage.setItem("email", formData.email);
//       sessionStorage.setItem("status", data.status);
//       sessionStorage.setItem("employeeId", data.employeeId || "");

//       if (data.roles.includes("ROLE_MANAGER")) navigate("/managerdashboard");
//       else if (data.roles.includes("ROLE_ADMIN")) navigate("/admindashboard");
//       else if (data.roles.includes("ROLE_HR")) navigate("/hrdashboard");
//       else navigate("/empdashboard");

//     } else {
//       setAttempts(prev => {
//         const updated = prev + 1;

//         if (updated >= 5) {
//           toast.error("Too many failed attempts! Locked for 5 minutes.");
//           sessionStorage.setItem("loginLockTime", Date.now());
//         } else {
//           toast.error("❌ Invalid credentials!", {
//             position: "top-center",
//           });
//         }

//         return updated;
//       });
//     }

//   } catch (err) {
//     console.error("Error:", err);
//     toast.error("🚨 Something went wrong!", { position: "top-center" });
//   } finally {
//     setLoading(false);
//   }
// };



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (attempts >= 5) {
      toast.error(
        "Too many failed attempts! Please contact administrator or use Forgot Password."
      );
      return;
    }

    // VALIDATE BEFORE API
    if (!validateForm()) return;

    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        // toast.success("✅ Login successful!", { position: "top-center" });

        sessionStorage.setItem("token", data.token);
        localStorage.setItem("token", data.token);
        sessionStorage.setItem("userId", data.id);
        sessionStorage.setItem("roles", JSON.stringify(data.roles));
        sessionStorage.setItem("email", formData.email);
        sessionStorage.setItem("status", data.status);
        sessionStorage.setItem("employeeId", data.employeeId || "");
        sessionStorage.setItem("username", data.username || "");

        if (data.roles.includes("ROLE_ADMIN")) navigate("/admindashboard");
        else if (data.roles.includes("ROLE_MANAGER")) navigate("/managerdashboard");
        else if (data.roles.includes("ROLE_HR")) navigate("/hrdashboard");
        else navigate("/empdashboard");

      }else {
  setAttempts(prev => {
    const updated = prev + 1;

    if (updated >= 5) {
      toast.error(
        "Too many failed attempts! Please contact administrator or use Forgot Password."
      );
    } else {
      toast.error("Please add correct email and password!", {
        position: "top-center",
      });
    }

    return updated;
  });
}
    } catch (err) {
      console.error("Error:", err);
      toast.error("🚨 Something went wrong!", { position: "top-center" });
    } finally {
      setLoading(false);
    }
  };

  const bgImage =
    "https://images.pexels.com/photos/3184360/pexels-photo-3184360.jpeg?auto=format&fit=crop&w=1600&q=80";

  return (
    <div
      className="d-flex flex-column flex-md-row vh-100"
      style={{
        fontFamily: "'Poppins', sans-serif",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(135deg, rgba(15, 23, 42, 0.85) 30%, rgba(3, 7, 18, 0.9) 100%)",
          zIndex: 0,
        }}
      ></div>

      <div className="col-md-6 d-flex align-items-center justify-content-center text-white position-relative">
        <div className="text-center px-4" style={{ zIndex: 1 }}>
          <img
            src={logo}
            alt="Logo"
            width="200"
            style={{ filter: "drop-shadow(0 0 8px #fff)" }}
            className="mb-4 animate-float"
          />
          <h1
            className="fw-bold mb-3"
            style={{
              fontSize: "2.5rem",
              background: "linear-gradient(90deg, #ffffff, #b2b2ff)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Simplify Work,
            <br /> Amplify Results.
          </h1>
          <p style={{ color: "#ddd", fontSize: "1.05rem" }}>
            Experience a simpler, smarter way to manage your work with BALSUITE.
          </p>
        </div>
      </div>

      <div className="col-md-6 d-flex align-items-center justify-content-center position-relative">
        <div
          className="p-5 shadow-lg rounded-4 text-white"
          style={{
            width: "100%",
            maxWidth: "420px",
            backdropFilter: "blur(15px)",
            background: "rgba(255, 255, 255, 0.12)",
            border: "1px solid rgba(255, 255, 255, 0.3)",
            zIndex: 1,
            animation: "slideUp 0.8s ease-in-out",
            boxShadow: "0 8px 30px rgba(0,0,0,0.3)",
          }}
        >
          <div className="text-center mb-4">
            <h3
              className="fw-bold mb-2"
              style={{
                background: "linear-gradient(90deg, #00c6ff, #0072ff)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Welcome Back
            </h3>
            <p style={{ color: "#b8c6ff" }}>Sign in to continue</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="form-label fw-semibold text-light">Email</label>
              <input
                type="text"
                name="email"
                className="form-control bg-transparent text-white"
                style={{
                  borderColor: "rgba(255,255,255,0.5)",
                  borderRadius: "10px",
                  height: "45px",
                }}
                placeholder="Enter your email"
                required
                value={formData.email}
                onChange={handleChange}
                disabled={loading}
              />
            </div>

            <div className="mb-4 position-relative">
              <label className="form-label fw-semibold text-light">
                Password
              </label>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="form-control bg-transparent text-white"
                style={{
                  borderColor: "rgba(255,255,255,0.5)",
                  borderRadius: "10px",
                  height: "45px",
                }}
                placeholder="Enter your password"
                required
                onChange={handleChange}
                disabled={loading}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  top: "42px",
                  right: "14px",
                  cursor: "pointer",
                  color: "#fff",
                  opacity: 0.8,
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <div className="d-grid mb-4">
              <button
                type="submit"
                className="btn fw-semibold"
                disabled={loading}
                style={{
                  borderRadius: "10px",
                  background: "linear-gradient(90deg, #0072ff, #00c6ff)",
                  color: "white",
                  border: "none",
                  height: "45px",
                  letterSpacing: "0.5px",
                  boxShadow: "0 4px 15px rgba(0, 114, 255, 0.4)",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.transform = "scale(1.05)")
                }
                onMouseLeave={(e) =>
                  (e.target.style.transform = "scale(1.0)")
                }
              >
                {loading ? "Signing in..." : "Login"}
              </button>
            </div>

            <div className="text-center">
              <span
                onClick={() => setShowForgotModal(true)}
                style={{
                  cursor: "pointer",
                  color: "#b2d3ff",
                  textDecoration: "underline",
                  fontWeight: "500",
                }}
              >
                Forgot Password?
              </span>
            </div>
          </form>
        </div>
      </div>

      <ForgotPasswordModal
        show={showForgotModal}
        onClose={() => setShowForgotModal(false)}
      />

      <style>
        {`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes float {
          0% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
          100% { transform: translateY(0); }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        .form-control::placeholder {
          color: rgba(255,255,255,0.7);
        }
        .form-control:focus {
          box-shadow: 0 0 10px rgba(255,255,255,0.4);
          border-color: #fff;
        }
        `}
      </style>
    </div>
  );
};

export default LoginPage;
